import { useTranslation } from 'react-i18next';

import { PhoneEntryField } from '../../../shared/ui';
import { type LoginPhoneForm } from '../model/use-login-form';

type LoginPhoneEntryProps = {
  phoneForm: LoginPhoneForm;
};

export function LoginPhoneEntry({ phoneForm }: LoginPhoneEntryProps) {
  const { t } = useTranslation();

  return (
    <PhoneEntryField
      clearPhoneAriaLabel={t('login.clearPhoneAria')}
      countryCode={phoneForm.countryCode}
      countryCodeAriaLabel={t('login.countryCodeAria')}
      countryFlag={phoneForm.countryFlag}
      countryOptions={phoneForm.countryOptions}
      dataUi="auth-login-phone-entry"
      onClearPhone={phoneForm.clearPhone}
      onPhoneChange={phoneForm.setPhone}
      onSelectCountryCode={phoneForm.selectCountryCode}
      phoneAriaLabel={t('login.phoneAria')}
      phoneMask={phoneForm.phoneMask}
      phoneValue={phoneForm.phone}
    />
  );
}
